module.exports = __webpack_public_path__ + "img/vector.6d35d16d.svg";